import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";

import { mrsBoardingInfoLink } from "../core/apiLink";
import type { ISellerStatusName, ISellerStatusValue } from "@/core/helpers/enum.helper";

export namespace ApiRefundsServiceInfo {
  export type Status = ISellerStatusName;
  export type StatusValue = ISellerStatusValue;
  export interface ISeller {
    id?: string; // selector 中手动添加的字段
    sellerId: string;
    sellerName: string;
    region: string;
    status: Status;
    statusValue: StatusValue;
    areAllPermissionsActive: boolean;
    lackOfPermissions: IPermission[]; // 当前seller缺少的权限
    invUrl: string | null;
    hasAllRequiredPermissions: boolean;
    statusRollbackTime: string | null; // 合并为 string | null
    tokenDataIsActive?: boolean;
    tokenDataIsActiveInconsistent?: boolean;
    spnClientName?: string;
    authorizedRemovalTime?: string;
    allPermissions: IPermission[]; // 当前seller所有的权限
    spnFlow: boolean; // 是否是子账号, false 代表的是子账号 - 走子账号逻辑
    lackAwdPermission: boolean; // 控制AWD显示,true && statusValue == 4 代表要显示 AWD Access Required 标识
  }

  export interface IPermission {
    section: string;
    name: string;
    type: string;
    optional?: boolean;
    required?: boolean;
    isMissing?: boolean;
  }

  export interface IServiceInfo {
    sellers: ISeller[];
  }

  export interface IResponse {
    data: IServiceInfo;
    success: boolean;
    message: string | null;
    code: number;
  }

  interface IRequest extends StringifiableRecord {
    sellerId?: string;
  }

  export const get = (params: IRequest, signal?: AbortController["signal"]) =>
    baseFetch<IRequest, IResponse>({
      url: getUrlWithSearchParams(mrsBoardingInfoLink, params),
      method: "GET",
      withCredentials: true,
      useSessionAccountId: true,
      signal,
    });
}
